export default __webpack_public_path__ + "170dddfca278d3c2ad4a977922707d70.woff";